import { render, staticRenderFns } from "./store-performance.vue?vue&type=template&id=bd0040d6&scoped=true&"
import script from "./store-performance.vue?vue&type=script&lang=js&"
export * from "./store-performance.vue?vue&type=script&lang=js&"
import style0 from "./store-performance.vue?vue&type=style&index=0&id=bd0040d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0040d6",
  null
  
)

export default component.exports